const FEATURES_KEY = 'features'

export const FEATURES = {
  RENTABILITY: 'rentability',
  EASYTOKEN: 'easytoken',
  MGM_V2: 'mgm_v2',
  CREDIT_WITHDRAWAL: 'credit_withdrawal'
}

export const getFeatures = () => JSON.parse(localStorage.getItem(FEATURES_KEY)) || []

export const getFeature = feature => getFeatures() &&
  getFeatures().find(item => item === feature)

export const hasFeature = (feature, features = getFeatures()) =>
  features.length ? features.find(item => item === feature) : false

export const hasFeatureSome = (feature, features = getFeatures()) =>
  features.length ? features.some(item => item === feature) : false

export const setFeatures = features => {
  localStorage.setItem(FEATURES_KEY, JSON.stringify(features))
}
